module.exports = __webpack_public_path__ + "static/media/typepo.23bb16c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/typepo.svg
// module id = 194
// module chunks = 0